module.exports = __webpack_public_path__ + "static/media/home_avatar6.dff49098.png";